/**
*
* RedHeroNoImage
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import setLanguageContent from 'helpers/setLanguageContent';
import formatDate from 'helpers/formatDate';

import Wrapper from 'components/Templates/dynamics/Wrapper';

class RedHeroNoImage extends React.PureComponent {

  render() {


    const {
      commonData,
      openEditor,
      commonProps,
      defaultValues,
      language
    } = this.props;

    const {
      defaultVenueData,
      dateFrom,
      dateTo,
      timezone,
      city,
      isOnline,
      dateFromWithTime,
      dateToWithTime
    } = defaultValues;

    const dateToValue = formatDate(dateFromWithTime ? dateFromWithTime : dateFrom, dateToWithTime ? dateToWithTime : dateTo, timezone);

    const {
      faviconImage
    } = commonProps;

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'horizontalWrapper'}
          editorData={
                {
                  editorType: 'horizontalWrapper',
                  ...commonData
                }
              }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'heroCenterWrapper'}
            editorData={
                {
                  editorType: 'heroCenterWrapper',
                  ...commonData
                }
              }
          >
            {
              defaultVenueData || dateToValue ? (
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'eventVenueWrapper'}
                  editorData={
                      {
                        editorType: 'eventVenueWrapper',
                        ...commonData
                      }
                    }
                >
                  {
                    dateToValue ? (
                      <Wrapper
                      {...commonProps}
                      
                      typeOfStyle={'eventDate'}
                      editorData={
                          {
                            editorType: 'eventDate',
                            ...commonData
                          }
                        }
                    >
                      {dateToValue}
                    </Wrapper>
                    ) : ''
                  }

                  {
                    defaultVenueData ? (
                      <>
                        <Wrapper
                          {...commonProps}
                          
                          typeOfStyle={'eventVenueTitle'}
                          editorData={
                              {
                                editorType: 'eventVenueTitle',
                                ...commonData
                              }
                            }
                        >
                          {setLanguageContent(defaultVenueData, 'title', language)}
                        </Wrapper>
                        <Wrapper
                          {...commonProps}
                          
                          typeOfStyle={'eventVenueAddress'}
                          editorData={
                              {
                                editorType: 'eventVenueAddress',
                                ...commonData
                              }
                            }
                        >
                          {setLanguageContent(defaultVenueData, 'address', language)}
                        </Wrapper>
                        <Wrapper
                          {...commonProps}
                          
                          typeOfStyle={'eventVenueCity'}
                          editorData={
                              {
                                editorType: 'eventVenueCity',
                                ...commonData
                              }
                            }
                        >
                          {setLanguageContent(defaultVenueData, 'city', language)}
                        </Wrapper>
                      </>
                    ) : city && !isOnline  ? (
                      <Wrapper
                        {...commonProps}
                        
                        typeOfStyle={'eventCity'}
                        editorData={
                            {
                              editorType: 'eventCity',
                              ...commonData
                            }
                          }
                      >
                        {city}
                      </Wrapper>
                    ) : ''
                  }
                </Wrapper>
              ) : ''
            }

            {
              faviconImage ? (
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'faviconImage'}
                  backgroundImage={faviconImage}
                  editorData={
                    {
                      editorType: 'faviconImage',
                      ...commonData
                    }
                  }
                />
              ) : ''
            }
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'title'}
              defaultValues={commonProps.pages.find(page => page.pageId === commonData.pageId)}
              type={'text'}
              editorData={
                  {
                    editorType: 'title',
                    ...commonData
                  }
                }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'paragraph'}
              type={'text'}
              editorData={
                  {
                    editorType: 'paragraph',
                    ...commonData
                  }
                }
            />
           <Wrapper
              {...commonProps}
              
              typeOfStyle={'headlineSponsorTitle'}
              defaultValues={
                {
                  headlineSponsorTitle: 'Sponsor'
                }
              }
              type={'text'}
              editorData={
                  {
                    editorType: 'headlineSponsorTitle',
                    ...commonData
                  }
                }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'headlineSponsorLogo'}
              editorData={
                  {
                    editorType: 'headlineSponsorLogo',
                    ...commonData
                  }
                }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'buttonsCenterWrapper'}
              editorData={
                  {
                    editorType: 'buttonsCenterWrapper',
                    ...commonData
                  }
                }
            >
              <Wrapper
                {...commonProps}
                
                type={'text'}
                typeOfStyle={'buttonHeroPrimary'}
                editorData={
                    {
                      editorType: 'buttonHeroPrimary',
                      ...commonData
                    }
                  }
              />
              <Wrapper
                {...commonProps}
                
                type={'text'}
                typeOfStyle={'buttonHeroSecondary'}
                editorData={
                    {
                      editorType: 'buttonHeroSecondary',
                      ...commonData
                    }
                  }
              />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );
  }
}

RedHeroNoImage.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  defaultValues: PropTypes.object,
};

export default RedHeroNoImage;